window.waveCustomerForm = window.waveCustomerForm || {};

window.waveCustomerForm.constants = {
  divIDCustomerForm: 'divCustomerForm',
  divIDBackground: 'divCustomerFormBackground',
  divIDPopup: 'divCustomerFormPopup',
  // divIDIframe: 'divCustomerFormIframe',
  divIDMain: 'divCustomerFormMain',
  divIDLoading: 'divCustomerFormLoading',
  
  urlCustomerForm: 'https://account-registration-customer-form-dev.wavecommerce.hk/',
};

window.waveCustomerForm.openPopup = ({ variantId, customerFormId }) => {
  const app = window.waveCustomerForm;
  const CONSTANTS = app.constants;
  const utils = app.utils;

  const landingUrl = window.location.href;

  /*
  const params = new URLSearchParams({
    shop: window.Shopify.shop,
    root: window.Shopify.shop + window.Shopify.routes.root.replace(/\/$/, ''),
    landingUrl, // TODO
    variantId,
    customerFormId,
  });
  */
  
  // add css class to lock scrolling

  const htmlRoot = document.getElementsByTagName( 'html' )[0]; // '0' to assign the first (and only `HTML` tag)
  htmlRoot.classList.add('html--popup-active');
  
  app.CustomerForm = document.createElement('div');
  app.CustomerForm.setAttribute('id', CONSTANTS.divIDCustomerForm);

  const popup = document.createElement('div');
  popup.setAttribute('id', CONSTANTS.divIDPopup);
  
  const background = document.createElement('div');
  background.setAttribute('id', CONSTANTS.divIDBackground);
  background.addEventListener('click', window.waveCustomerForm.closePopup)

  /*
  const urlIframe = `${CONSTANTS.urlCustomerForm}?${params.toString()}`;
  const iframe = document.createElement('iframe');
  iframe.setAttribute('src', urlIframe);
  iframe.setAttribute('id', CONSTANTS.divIDIframe);
  */
  const main = document.createElement('div');
  main.setAttribute('id', CONSTANTS.divIDMain);
  main.innerHTML = `
    <customer-form-element
      shop="${window.Shopify.shop}"
      root="${window.Shopify.shop + window.Shopify.routes.root.replace(/\/$/, '')}"
      landing-url="${landingUrl}"
      variant-id="${variantId}"
      customer-form-id="${customerFormId}"
      locale="zh-TW"
    ></customer-form-element>
  `

  const closeButtonRow = document.createElement('div')
  closeButtonRow.classList.add('popup-close-button-row')

  const closeButton = document.createElement('div')
  closeButton.classList.add('popup-close-button')

  closeButton.innerHTML = '&times;'
  closeButton.addEventListener('click', window.waveCustomerForm.closePopup)

  closeButtonRow.appendChild(closeButton)

  popup.appendChild(closeButton)
  // popup.appendChild(iframe)
  popup.appendChild(main)

  app.CustomerForm.appendChild(background);
  app.CustomerForm.appendChild(popup);
  
  document.body.appendChild(app.CustomerForm);
};

window.waveCustomerForm.closePopup = () => {
  // remove css class to allow scrolling
  const htmlRoot = document.getElementsByTagName( 'html' )[0]; // '0' to assign the first (and only `HTML` tag)
  htmlRoot.classList.remove('html--popup-active');
  
  const app = window.waveCustomerForm;
  app.CustomerForm.remove();
}
